import cn from 'classnames';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { useBrandingStyleVariables } from 'hooks/branding-style-variables';

import { Button } from 'components/FormComponents';

import styles from './CustomButton.module.scss';

export const CustomButton = ({
  completed,
  blockOnComplete,
  brand,
  type = 'primary',
  icon,
  onlyIcon = false,
  className,
  disabled,
  prependIcon,
  children,
  submit,
  small = false,
  marginTop = true,
  width = 'full',
  rounded = false,
  checkedIconPositionedAbsolute = true,
  onClick = () => {},
  dataTestId,
}) => {
  const bradingStyleVariables = useBrandingStyleVariables(brand);

  return (
    <Button
      type={type}
      className={cn(styles.root, styles[`root--${type}`], {
        [className]: className,
        [styles.rootCompleted]: completed,
        [styles.small]: small,
        [styles.marginTop]: marginTop,
        [styles[width]]: width,
        [styles.appendIcon]: !prependIcon,
        [styles.rounded]: rounded,
      })}
      style={bradingStyleVariables}
      disabled={disabled}
      onClick={() => {
        if (!blockOnComplete || !completed) onClick();
      }}
      prependIcon={prependIcon}
      icon={icon}
      onlyIcon={onlyIcon}
      submit={submit}
      dataTestId={dataTestId}>
      {completed && (
        <FeatherIcon
          style={{ backgroundColor: brand.color_button }}
          icon="check"
          className={cn(styles.completedIcon, { 'u-absolute': checkedIconPositionedAbsolute })}
        />
      )}
      {children}
    </Button>
  );
};
